import { combineReducers } from "redux";
import ads from "./ads";
import captions from "./captions";
import companyNavbar from "./companyNavbar";
import controls from "./controls";
import cuepointPreviews from "./cuepointPreviews";
import device from "./device";
import forceChapterCover from "./forceChapterCover";
import inactivity from "./inactivity";
import keysPressed from "./keysPressed";
import loading from "./loading";
import modals from "./modals";
import playbackState from "./playbackState";
import playerOptions from "./playerOptions";
import route from "./route";
import story from "./story";
import storyPublishSettings from "./storyPublishSettings";
import userInteraction from "./userInteraction";
import viewport from "./viewport";
import volume from "./volume";
import windowIsBlurred from "./windowIsBlurred";

const appReducer = combineReducers({
  ads,
  captions,
  companyNavbar,
  controls,
  cuepointPreviews,
  device,
  forceChapterCover,
  inactivity,
  keysPressed,
  loading,
  modals,
  playbackState,
  playerOptions,
  route,
  story,
  storyPublishSettings,
  userInteraction,
  viewport,
  volume,
  windowIsBlurred,
});

export default appReducer;
